import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const RejectChanges = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path opacity="0.3" d="M4.5 7L16.5 7" stroke={color} strokeLinecap="round" />
        <path opacity="0.3" d="M4.5 11H8.5" stroke={color} strokeLinecap="round" />
        <path d="M12 11L19.9044 18.9044" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.9044 11L12.0001 18.9044" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  },
)

export default RejectChanges
